import React from 'react';
import { GoalCompletion } from '../../../api/adminDashboard';
import DashboardCard from './DashboardCard';

interface GoalCompletionCardProps {
    goalCompletion: GoalCompletion;
}

const GoalCompletionCard: React.FC<GoalCompletionCardProps> = ({ goalCompletion }) => (
    <DashboardCard title="Goal Completion" className="ad-col-goal">
        <div className="ad-goal-body">
            <div className="ad-goal-row">
                <div className="ad-goal-track">
                    <div className="ad-goal-fill" style={{ width: `${goalCompletion.completionPct}%` }} />
                </div>
                <span className="ad-goal-pct">{goalCompletion.completionPct}%</span>
            </div>
            <div className="ad-goal-caption">
                <div>
                    <strong>{goalCompletion.completedRequests.toLocaleString()}</strong>
                    <span> - completed requests</span>
                </div>
                <div>
                    <strong>{goalCompletion.failedRequests.toLocaleString()}</strong>
                    <span> - failed requests</span>
                </div>
            </div>
        </div>
    </DashboardCard>
);

export default GoalCompletionCard;
